// src/Components/Profile/TabDescargas.jsx
import { useState, useEffect } from 'react';
import './TabDescargas.css';

/**
 * Props:
 *   idCliente — ID del cliente logueado
 *   baseURL   — URL base de tu API (ej: "https://tudominio.com/api")
 */
const TabDescargas = ({ idCliente, baseURL }) => {
  const [descargas, setDescargas] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState(false);

  useEffect(() => {
    if (!idCliente) return;

    fetch(`${baseURL}/descargasGet.php?idCliente=${idCliente}`)
      .then(r => {
        if (!r.ok) throw new Error('Error al obtener descargas');
        return r.json();
      })
      .then(data => {
        setDescargas(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, [idCliente, baseURL]);

  if (loading) {
    return (
      <div className="descargasEstado">
        <span className="descargasSpinner" />
        <p>Cargando descargas...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="descargasEstado descargasError">
        <p>⚠️ No se pudieron cargar tus descargas. Intentá más tarde.</p>
      </div>
    );
  }

  if (!descargas.length) {
    return (
      <div className="descargasEstado descargasVacio">
        <span className="descargasVacioIcono">📭</span>
        <p>No tenés archivos disponibles para descargar.</p>
        <small>Los archivos aparecen cuando tu pedido está completado.</small>
      </div>
    );
  }

  return (
    <div className="descargasContainer">
      {descargas.map((item, i) => (
        <div key={i} className="descargaItem">
          <div className="descargaIcono">📄</div>
          <div className="descargaInfo">
            <span className="descargaNombre">{item.nombreArchivo}</span>
            <span className="descargaMeta">
              Pedido #{item.idPedido}
              {item.fecha && <> · {item.fecha}</>}
            </span>
          </div>
          <a
            href={item.urlDescarga}
            download
            className="btnDescargar"
            target="_blank"
            rel="noreferrer"
          >
            ⬇ Descargar
          </a>
        </div>
      ))}
    </div>
  );
};

export default TabDescargas;
